<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商户管理</el-breadcrumb-item>
      <el-breadcrumb-item>商户列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-row :gutter="0">
        <el-col :span="12">
          <el-input placeholder="请输入查询内容" v-model="queryInfo.query" class="input-with-select" clearable style="width: 300px" @clear="getqiyeList" @change="getqiyeList">
            <el-button slot="append" icon="el-icon-search" @click="getqiyeList"></el-button>
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="addDialog">添加商户</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="0" class="el_row_two">
        <el-col :span="24">
          <el-table :data="qiyeList" style="width: 100%" border stripe>
            <!-- <el-table-column type="index" label="序号" width="80"></el-table-column> -->
            <el-table-column prop="uid" label=" 序号" width="80"></el-table-column>
            <el-table-column prop="qiye_bianhao" label="商户编号"></el-table-column>
            <el-table-column prop="qiye_xuliehao" label="序列号"></el-table-column>
            <el-table-column prop="qiye_name" label="商户名称"></el-table-column>
            <el-table-column label="城市"  v-if="false">
                            <template v-slot="scope">
                                {{ scope.row.chengshi_name }}
                            </template>
                        </el-table-column>
            <el-table-column prop="qiye_lxr" label="管理人"></el-table-column>
            <el-table-column prop="qiye_mob" label="手机"></el-table-column>

            <el-table-column prop="yong_flag" label="状态">
              <template v-slot="scope">
                <el-switch :active-value="1" :inactive-value="0" v-model="scope.row.yong_flag"></el-switch>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template v-slot="scope">
                <el-tooltip class="item" effect="dark" content="修改" placement="top" :enterable="false">
                  <el-button type="primary" icon="el-icon-edit" @click="showEditDialog(scope.row.uid)" circle size="mini"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="删除" placement="top" :enterable="false">
                  <el-button type="danger" icon="el-icon-delete" circle size="mini" @click="deleteForm(scope.row.uid)"></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <!-- 分页 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="queryInfo.pageNum" :page-sizes="[10, 50]" :page-size="queryInfo.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
        <!--分页组件，其中handleSizeChange 条数下拉触发事件，  handleCurrentChange  选择分页出发事件 currentPage2 当前页绑定 page-sizes 下拉显示列表 page-size 每页多少条绑定 layout 显示分页的元素 total 合计条数绑定  -->
      </el-pagination>
      <!-- 添加商户部分 -->
      <el-dialog title="添加商户" :visible.sync="addDialogVisible" width="50%" @close="addDoalogClosed">
        <el-form ref="addFormRef" :model="addForm" :rules="addFormRules" label-width="100px">
          <el-form-item label="商户编号" prop="qiye_bianhao">
            <el-input v-model="addForm.qiye_bianhao" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="序列号2" prop="qiye_name">
            <el-input v-model="addForm.qiye_xuliehao"></el-input>
          </el-form-item>
          <el-form-item label="商户名称2" prop="qiye_name">
            <el-input v-model="addForm.qiye_name"></el-input>
          </el-form-item>
          <el-form-item label="城市" prop="product_chengshi">
                    <el-select
                    v-model="addForm.chengshi_uid"
                    placeholder="请选择城市"
                    >
                    <el-option
                    v-for="item in chengshiList"
                    :key="item.uid"
                    :label="item.chengshi_bianhao+'|'+item.chengshi_name"
                    :value="item.uid"
                    ></el-option>
                    </el-select>
                    </el-form-item>
          <el-form-item label="商户管理人" prop="qiye_lxr">
            <el-input v-model="addForm.qiye_lxr"></el-input>
          </el-form-item>

          <el-form-item label="联系手机号" prop="qiye_mob">
            <el-input v-model="addForm.qiye_mob" max="11" min="10"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="addqiye" :disabled="add_isDisable">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 修改商户信息 -->
      <el-dialog title="修改商户信息" :visible.sync="editDialogVisible" width="50%" @close="editDoalogClosed">
        <el-form ref="editFormRef" :model="editForm" :rules="addFormRules" label-width="100px">
          <el-form-item label="商户uid" prop="qiye_uid">
            <el-input v-model="editForm.qiye_uid" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="商户编号" prop="qiye_bianhao">
            <el-input v-model="editForm.qiye_bianhao" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="序列号" prop="qiye_bianhao">
            <el-input v-model="editForm.qiye_xuliehao" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="商户名称" prop="qiye_name">
            <el-input v-model="editForm.qiye_name"></el-input>
          </el-form-item>

          <el-form-item label="商户管理人" prop="qiye_lxr">
            <el-input v-model="editForm.qiye_lxr"></el-input>
          </el-form-item>

          <el-form-item label="联系手机号" prop="qiye_mob">
            <el-input v-model="editForm.qiye_mob" max="11" min="10"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="updateqiye">确 定</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
import { checkMobileTest } from '../../tongyong/config/validator'
export default {
  data() {
    // var checkMobile = (rule, value, cb) => {
    //  const regMobil = /^(0|86|17951)?(13[0-9]|15[0123456789]|17[678]|18[0-9]|14[57])[0-9]{8}$/
    // if (regMobil.test(value)) {
    //    return cb()
    //  }
    //  cb(new Error('请输入合法的手机号!'))
    //  }
    return {
      // 获取用户列表参数
      queryInfo: {
        //   token: window.sessionStorage.getItem('token'), // 递交数据，必须携带token ，进行验证
        C_type: 'get_list',
        C_table_name: 'qiye_list',
        query: '',
        pageNum: 1,
        pageSize: 10
      },
      qiyeList: [],
      //  recordCount: 0,
      total: 0,
      addDialogVisible: false,
      editDialogVisible: false,
      add_isDisable: false,
      //  添加表单数据项
      addForm: {
        C_type: 'qiye_add',
        qiye_bianhao: '',
        qiye_name: '',
        qiye_lxr: '',
        qiye_mob: '',
        qiye_xuliehao: ''
      },
      // 用于修改数据绑定
      editForm: {},
      // 表单规则项
      addFormRules: {
        qiye_name: [
          { required: true, message: '请输入商户名称', trigger: 'blur' },
          { min: 1, max: 30, message: '必须1到30位字符 ', trigger: 'blur' }
        ],
        qiye_lxr: [
          { required: true, message: '请输入商户管理员', trigger: 'blur' },
          { min: 1, max: 10, message: '必须1到10位字符', trigger: 'blur' }
        ],
        qiye_mob: [{ validator: checkMobileTest.bind(this.addForm && this.addForm.qiye_mob) }]
      }
    }
  },
  created() {
    this.getqiyeList()
  },
  methods: {
    async getqiyeList() {
      const { data: res } = await this.$http.get('get_api', {
        params: this.queryInfo
      })
      // console.log(JSON.parse(res.data))
      this.qiyeList = JSON.parse(res.data)[0].dataList

      if (!this.qiyeList) return
      this.qiyeList.forEach(function (item) {
        item.yong_flag = item.yong_flag === 1
      })

      this.total = JSON.parse(res.data)[0].total

      // console.log(this.total);
    },
    //  分页第一项下拉触发

    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize
      this.getqiyeList()
    },
    // 选择页数触发
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage
      this.getqiyeList()
    },
    addDoalogClosed() {
      this.$refs.addFormRef.resetFields()
    },
    async addDialog() {
      const { data: res } = await this.$http.get('get_api', {
        params: { C_type: 'get_bianhao', C_table_type: 6 }
      })
      console.log(JSON.parse(res.data)[0].bianhao_s)
      this.addForm.qiye_bianhao = JSON.parse(res.data)[0].bianhao_s
      this.addForm.qiye_xuliehao = JSON.parse(res.data)[0].qiye_xuliehao
      // this.total = JSON.parse(res.data)[0].total
      this.addDialogVisible = true
    },
    addqiye() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return 1
        this.add_isDisable = true
        setTimeout(() => {
          this.add_isDisable = false // 点击一次时隔两秒后才能再次点击
        }, 2000)
        const { data: res } = await this.$http.post('api', this.addForm)
        // console.log(JSON.parse(res.data)[0].status);
        if (JSON.parse(res.data)[0].status !== 200) {
          this.$message.error('添加失败')
          return
        }
        this.$message.success('添加成功')
        this.getqiyeList()
        this.addDialogVisible = false
      })
    },
    showEditDialog(uid) {
      this.editDialogVisible = true
      this.qiyeInfo(uid)
    },
    editDoalogClosed() {
      this.$refs.editFormRef.resetFields()
    },
    async qiyeInfo(uid) {
      const { data: res } = await this.$http.get('get_api', {
        params: { C_table_name: 'qiye_info', uid: uid, C_type: 'get_info' }
      })
      // console.log(JSON.parse(res.data))
      console.log(res.data)
      if (JSON.parse(res.data)[0].status !== 200) {
        return this.$message.error('读取失败')
      }

      this.editForm = JSON.parse(res.data)[0].data[0]
    },
    async updateqiye() {
      // console.log(123)
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) return this.$message.error('验证错误！')
        const { data: res } = await this.$http.post('api', {
          C_type: 'qiye_update',
          qiye_uid: this.editForm.qiye_uid,
          qiye_name: this.editForm.qiye_name,
          qiye_lxr: this.editForm.qiye_lxr,
          qiye_mob: this.editForm.qiye_mob
        })

        if (JSON.parse(res.data)[0].status !== 200) {
          this.$message.error('更新失败')
          return
        }
        this.$message.success('更新成功')
        this.getqiyeList()
        this.editDialogVisible = false
      })
    },
    // 删除一条记录
    async deleteForm(qiyeUid) {
      // 此处通过异步获取操作行为，而不用then ，来避免异步嵌套
      // 异步操作有2个，1个对话框等待，1个是网络请求
      const comfirmResult = await this.$confirm('确定删除该条记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch((err) => err)
      console.log(comfirmResult)
      if (comfirmResult === 'cancel') return this.$message.info('已经取消删除')
      const { data: res } = await this.$http.post('api', {
        C_type: 'record_delete',
        C_table_name: 'qiye_del',
        C_data1: qiyeUid
      })
      if (JSON.parse(res.data)[0].status !== 200) {
        this.$message.error('删除失败')
        return
      }
      this.$message.success('删除成功')
      this.getqiyeList()
    }
  }
}
</script>
<style lang="less" scoped>
.card_two {
  margin-top: 30px;
  box-shadow: none !important;
}
.el_row_two {
  margin-top: 30px;
}
</style>
